<template>
  <div>
    <el-table :data="userList" border height="calc(100vh - 300px)">
      <el-table-column prop="userId" label="用户UID" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.userId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderIp" label="下单IP" min-width="120">
      </el-table-column>
      <el-table-column
        prop="ipAttribution"
        label="IP归属地"
        min-width="140"
        show-overflow-tooltip
      />
      <el-table-column
        prop="deviceInfo"
        label="设备信息"
        min-width="220"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ formatDeviceInfo(scope.row.deviceInfo) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="version"
        label="App/客户端版本"
        min-width="140"
        show-overflow-tooltip
      />
      <el-table-column prop="platform" label="设备类型" min-width="110" />
      <el-table-column prop="createTime" label="创建时间" min-width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'UserOrderLogList',
  components: {
    Pagination,
  },
  methods: {
    formatDeviceInfo(val) {
      if (val == null || val === '') {
        return '-';
      }
      if (typeof val === 'string') {
        return val;
      }
      try {
        return JSON.stringify(val);
      } catch (e) {
        return String(val);
      }
    },
    pageChanged(pagination) {
      this.$emit('refresh', pagination);
    },
  },
  computed: {
    ...mapState('userOrderLog', ['userList', 'pagination', 'totalCount']),
  },
};
</script>
